import { PropsWithChildren } from "react";
import clsx from "clsx";

export const DrawerScrollableContainer = ({
  className,
  children,
}: { className?: string } & PropsWithChildren) => (
  <div
    className={clsx(
      "max-h-[calc(100dvh_-_106px)] overflow-y-auto px-4 md:max-h-[calc(100dvh_-_136px)] md:px-14",
      className,
    )}
  >
    {children}
  </div>
);
